import { render, staticRenderFns } from "./InjuryDetailsDialog.vue?vue&type=template&id=2e0afd1d&scoped=true"
import script from "./InjuryDetailsDialog.vue?vue&type=script&lang=js"
export * from "./InjuryDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./InjuryDetailsDialog.vue?vue&type=style&index=0&id=2e0afd1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0afd1d",
  null
  
)

export default component.exports